import axios from 'axios';
import store from '../store';
import router from '../router';
import { Message } from 'element-ui';

const service = axios.create({
  baseURL: '/api',
  timeout: 15000
});

/**
 * GET 查询参数序列化：数组使用重复键名 classIds=1&classIds=2，
 * 兼容 Spring @RequestParam List<Long> classIds（axios 默认会发 classIds[]=1）。
 */
export function serializeGetParams(params) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, val]) => {
    if (val === null || val === undefined || val === '') return;
    if (Array.isArray(val)) {
      val.forEach(item => {
        if (item !== null && item !== undefined && item !== '') {
          search.append(key, item);
        }
      });
    } else {
      search.append(key, val);
    }
  });
  return search.toString();
}

service.interceptors.request.use(
  config => {
    const token = store.getters['user/token'];
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

service.interceptors.response.use(
  response => {
    const res = response.data;
    // 后端统一返回 Result: { code, msg, data }
    if (res && typeof res.code !== 'undefined' && res.code !== 0) {
      // 登录过期专门处理
      if (res.code === -401) {
        Message.error(res.msg || '登录已过期，请重新登录');
        // 清理本地登录状态
        store.dispatch('user/logout');
        // 跳转到登录页（带上当前路径，方便下次登录后跳回）
        const current = router.currentRoute && router.currentRoute.fullPath;
        if (current && !current.startsWith('/login')) {
          router.replace({ path: '/login', query: { redirect: current } }).catch(() => {});
        } else {
          router.replace('/login').catch(() => {});
        }
      } else {
        Message.error(res.msg || '请求失败');
      }
    }
    return res;
  },
  error => {
    const data = error.response && error.response.data;
    const msg = (data && data.msg) || error.message || '网络异常';
    Message.error(msg);
    // 不抛出异常，返回统一结构，避免打断页面交互
    return { code: -1, msg, data: null };
  }
);

export default service;

